var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-grid',{ref:"grid",attrs:{"rows":_vm.rows,"cols":_vm.cols,"size":_vm.size,"depth":0,"image":_vm.from,"css":_vm.gridCss,"tile-css":_vm.tileCss}})}
var staticRenderFns = []

export { render, staticRenderFns }